import i18n from './i18n';
// import { ElNotification } from 'element-ui'
import { Notification } from 'element-ui';

export function checkCookie() {
    if(navigator.cookieEnabled != true) {
        Notification.error({
            title: i18n.t("Cookie not enable"),
            message: i18n.t("Please enbale cookie to allow icode run on your browser"),
        });
    }
    if(navigator.doNotTrack && (!location.hostname.endsWith(".icode.org.cn"))) {
        Notification.error({
            title: i18n.t("Third party cookie not enable"),
            message: i18n.t("Please allow third party cookie to allow icode run on your browser"),
        });
    }
}


// WEBPACK FOOTER //
// ./src/utils/browserCheck.js